import { render } from "./BModalCompat.vue?vue&type=template&id=02394ed2"
import script from "./BModalCompat.vue?vue&type=script&lang=js"
export * from "./BModalCompat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__